import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, HeadingType, HeadingSize, Text, TextSize, ButtonState } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { DefaultSettings, ErrorMessage } from '@as-react/common-types';
import CustomerApi from '../../api/customer/CustomerApi';
import { getQuerystringByName } from '../../util/URLParamUtil';
import FormValidationUtil from '../../util/FormValidationUtil';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { DELAY } from '../../constants/GeneralConstants';
import { PasswordResetForm, PasswordResetFormView, } from '../../components/password-reset-form/PasswordResetForm';
import { getHomepageUrl } from '@as-react/common-utils';
const EVENT_PARAM_KEY = 'event';
const AccountPasswordResetContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint, root } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.buy, I18N_NAMESPACES.navigation]);
    const [customerUUID, setCustomerUUID] = useState('');
    const [isValidUUID, setIsValidUUID] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const [buttonState, setButtonState] = useState(ButtonState.INTERACTIVE);
    const [errorFeedback, setErrorFeedback] = useState('');
    useEffect(() => {
        var _a;
        const validateUUID = (uuid) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield CustomerApi.validatePasswordResetLink(servicesEndpoint, defaultRequestParams, uuid);
                setIsValidUUID(true);
                setShouldRender(true);
            }
            catch (_a) {
                setShouldRender(true);
            }
        });
        const uuid = (_a = getQuerystringByName(window.location.search, EVENT_PARAM_KEY)) !== null && _a !== void 0 ? _a : '';
        setCustomerUUID(uuid);
        validateUUID(uuid);
    }, []);
    const handleValidationDefault = (values) => {
        const errors = {};
        if (!values.password) {
            errors.password = t(ErrorMessage.ACCOUNT_REQUIRED);
        }
        else if (values.password.length < DefaultSettings.MIN_LENGTH_PASSWORD) {
            errors.password = t(ErrorMessage.ACCOUNT_MIN_LENGTH);
        }
        if (!values.repeatPassword) {
            errors.repeatPassword = t(ErrorMessage.ACCOUNT_REQUIRED);
        }
        else if (values.password !== values.repeatPassword) {
            errors.repeatPassword = t(ErrorMessage.PASSWORD_MATCH);
        }
        return errors;
    };
    const handleValidationEmail = (values) => {
        const errors = {};
        if (!values.email) {
            errors.email = t(ErrorMessage.ACCOUNT_REQUIRED);
        }
        else if (!FormValidationUtil.isValidEmailPattern(values.email)) {
            errors.email = t(ErrorMessage.INVALID_EMAIL);
        }
        return errors;
    };
    const handleSubmitDefault = (values) => __awaiter(void 0, void 0, void 0, function* () {
        setButtonState(ButtonState.LOADING);
        try {
            yield CustomerApi.resetPassword(servicesEndpoint, defaultRequestParams, customerUUID, values.password);
            setButtonState(ButtonState.FINISHED);
            if (errorFeedback) {
                setErrorFeedback('');
            }
            setTimeout(() => (window.location.href = getHomepageUrl(root)), DELAY.DELAY_3000);
        }
        catch (_a) {
            setButtonState(ButtonState.INTERACTIVE);
            setErrorFeedback(t('account:account.reset.password.error'));
        }
    });
    const handleSubmitEmail = (values) => __awaiter(void 0, void 0, void 0, function* () {
        setButtonState(ButtonState.LOADING);
        try {
            yield CustomerApi.sendPasswordResetMail(servicesEndpoint, defaultRequestParams, values.email);
            setButtonState(ButtonState.FINISHED);
            if (errorFeedback) {
                setErrorFeedback('');
            }
            setTimeout(() => (window.location.href = getHomepageUrl(root)), DELAY.DELAY_3000);
        }
        catch (_a) {
            setButtonState(ButtonState.INTERACTIVE);
            setErrorFeedback(t('navigation:flyout.account.error.operation.mail'));
        }
    });
    if (!shouldRender)
        return null;
    return (_jsx(Box, { paddingBlockStart: { base: '6', md: '7' }, paddingBlockEnd: { base: '10', md: '12', lg: '14' }, children: _jsxs(Box, { shadow: !isMobile ? 'lg' : undefined, paddingBlockEnd: { base: '4', md: '6', lg: '12' }, paddingBlockStart: { base: '6', md: '10' }, backgroundColor: "quiet", paddingInline: { base: '4', md: '12' }, marginInline: { base: '-4', md: '0' }, children: [isValidUUID ? (_jsx(_Fragment, { children: title.show && (_jsx(Box, { paddingBlockEnd: { base: '4', md: '8' }, children: _jsx(Heading, { type: HeadingType.TITLE, children: title.value || t('account:account.password.passwordOne') }) })) })) : (_jsxs(_Fragment, { children: [_jsx(Heading, { size: HeadingSize.S, children: t('account:account.reset.password.invalidtoken') }), _jsx(Box, { paddingBlockEnd: "6", paddingBlockStart: "3", children: _jsx(Text, { paragraph: true, size: TextSize.SMALL, children: t('account:account.passwordForgottenText') }) })] })), _jsx(PasswordResetForm, { validate: isValidUUID ? handleValidationDefault : handleValidationEmail, onSubmit: isValidUUID ? handleSubmitDefault : handleSubmitEmail, view: isValidUUID ? PasswordResetFormView.DEFAULT : PasswordResetFormView.EMAIL, buttonState: buttonState, errorFeedback: errorFeedback })] }) }));
};
export default AccountPasswordResetContainer;
